const AccountStatementGenerator = () =>
  import('../screens/AccountStatementGenerator/AccountStatementGenerator.vue');

export default [
  {
    component: AccountStatementGenerator,
    meta: {
      activeSidebarItemId: 'account-statement-generator',
      authority: 'account_statements:download',
      pageTitle: 'Account Statement Generator',
    },
    name: 'account-statement-generator',
    path: '/account-statement-generator',
  },
];
